export default {
  namespaced: true,
  state: {
    groupMsg: {},   // 用来存放当前拼团的信息
    goLiveNum:0,
  },
  mutations: {
    editGroupMsg(state, item) {
      state.groupMsg = item;
    },
    editGoLiveNum(state){
      state.goLiveNum += 1
    }
  },
};
